import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      x1="13.77"
      y1="15.624"
      x2="26.977"
      y2="15.624"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      x1="13.77"
      y1="20.411"
      x2="23.494"
      y2="20.411"
    />
    <polygon
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      points="9.542,9.384 9.705,9.384 32.313,9.384 
		32.313,26.847 14.93,26.833 9.542,31.117 	"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/MessageLine.jsx